/* stylelint-disable no-descending-specificity */
import React, { Component } from 'react';
import styled from 'styled-components';
import { Breadcrumb } from '@bijie/react-bnb';

import { Link } from '../../../routes';
import withI18n from '../../../utils/withI18n';
import FlexBox from '../../FlexBox';
import SingleBlog from '../single-blog';

const Container = styled(FlexBox)`
  flex-grow: 1;
  font-size: 14px;
  color: #666;
  background: #f8f8f8;

  .breadcrumb {
    width: 970px;
    margin: 22px auto 25px;

    a:hover {
      color: #f0b90b;
      text-decoration: underline;
    }
  }
`;

const Content = styled(FlexBox)`
  width: 970px;
  background: #fff;
  margin: 0 auto 56px;
  padding: 10px 0;
`;

type Props = {
  locale: string,
  info: Object,
};

export default
@withI18n('blog')
class BlogDetail extends Component<Props> {
  static defaultProps = {
    locale: 'en',
    info: {},
  };

  render() {
    const { locale, info } = this.props;

    return (
      <Container direction="column">
        <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <Link to={`/${locale}/blog`}><a>Blog</a></Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{info.title}</Breadcrumb.Item>
        </Breadcrumb>

        <Content>
          <SingleBlog isDetail={true} info={info} locale={locale} />
        </Content>
      </Container>
    );
  }
}
